import GridContainer from '../GridContainer';
import TextLink from '../TextLink';
import { twMerge } from 'tailwind-merge';

export default function BodyText(props) {
  return (
    <div
      id={props.id}
      className={twMerge(
        'grid-gap col-start-1 col-end-13 mb-2 text-[#424243] dark:text-white',
        props.col == 2
          ? 'md:columns-2 md:col-start-5 md:col-end-13'
          : 'md:col-start-5 md:col-end-13'
      )}>
      {props.title !== undefined && <h2 className="mt-4 mb-2 h2 font-workbench text-3xl">✴ {props.title}</h2>}
      <p className={`${props.caption ? 'opacity-60 caption ' : 'body font-semibold'}`}>{props.children}</p>
    </div>
  );
}